module.exports = __webpack_public_path__ + "002a98270a7e41d3d8ca31980578ece7.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-4/adidas.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-4/adidas.jpg
// module chunks = 40